import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "./const";

class AdminService {
  getShift(queryParams: string) {
    return axios.get(API_URL + "admin/shift?" + queryParams, {
      headers: authHeader(),
    });
  }

  getShiftById(shiftsEntityId: string) {
    return axios.get(API_URL + `admin/shift/${shiftsEntityId}`, {
      headers: authHeader(),
    });
  }

  getShiftId() {
    return axios.get(API_URL + "admin/shift/shiftid", {
      headers: authHeader(),
    });
  }

  deleteShift(shiftsEntityId: number, isHardDelete: boolean) {
    return axios.delete(
      API_URL +
        "admin/shift/" +
        shiftsEntityId +
        "?isharddelete=" +
        isHardDelete,
      {
        headers: authHeader(),
      }
    );
  }

  patchShift(body: any, shiftsEntityId: number) {
    return axios.patch(API_URL + "admin/shift/" + shiftsEntityId, body, {
      headers: authHeader(),
    });
  }

  getDeposit(queryParams: string) {
    return axios.get(API_URL + "admin/deposit?" + queryParams, {
      headers: authHeader(),
    });
  }

  getDepositById(depositEntityId: string) {
    return axios.get(API_URL + `admin/deposit/${depositEntityId}`, {
      headers: authHeader(),
    });
  }

  patchCash(payload: any, shiftCashEntityId: number) {
    return axios.patch(API_URL + `admin/cash/${shiftCashEntityId}`, payload, {
      headers: authHeader(),
    });
  }

  patchDeposit(payload: any, depositId: number) {
    return axios.patch(API_URL + `admin/deposit/${depositId}`, payload, {
      headers: authHeader(),
    });
  }

  deleteDeposit(depositId: number) {
    return axios.delete(API_URL + "admin/deposit/" + depositId, {
      headers: authHeader(),
    });
  }

  getCompanyBanks() {
    return axios.get(API_URL + "company-bank", { headers: authHeader() });
  }

  getCreditCard(queryParams: string) {
    return axios.get(API_URL + "admin/creditcard?" + queryParams, {
      headers: authHeader(),
    });
  }
  getCreditCardById(creditCardEntityId: number) {
    return axios.get(API_URL + `admin/creditcard/${creditCardEntityId}`, {
      headers: authHeader(),
    });
  }

  patchCreditCard(data: any, creditCardEntityId: number) {
    return axios.patch(
      API_URL + `admin/creditcard/${creditCardEntityId}`,
      data,
      {
        headers: authHeader(),
      }
    );
  }
}

export default new AdminService();
